import React, { useEffect, useMemo } from "react";

import { Button, Table, Typography } from "clearsense-ui/components";

import { getTableData } from "./data";

const DistributionTable = ({
  node,
  modelGraphNodeMap,
  modelDriverNodeMap,
  openChartModal,
}) => {
  const table = useMemo(
    () => node && getTableData(node, modelGraphNodeMap, modelDriverNodeMap),
    [node, modelGraphNodeMap, modelDriverNodeMap]
  );

  useEffect(
    () =>
      table &&
      document
        .getElementById("model-graph-node-table")
        .scrollIntoView({ behavior: "smooth" }),
    [table]
  );

  if (!modelGraphNodeMap || !modelDriverNodeMap) return null;

  return (
    <div
      className="mt-4 bg-white dark:bg-gray-800 border-2"
      id="model-graph-node-table"
    >
      {table ? (
        <>
          <div className="flex items-center justify-between p-4 bg-gray-200">
            <Typography type="semibold">{table?.title}</Typography>
            <Button
              label="View Distributions"
              size="small"
              style="secondary"
              onClick={openChartModal}
              disabled={!node?.selectable || !table?.rows?.length}
            />
          </div>
          <Table
            columnData={table?.columns || []}
            rowData={
              table?.rows?.slice(0, Math.min(table.rows?.length, 30)) || []
            }
          />
        </>
      ) : (
        <Typography className="flex items-center justify-center text-gray-300 h-28">
          NO NODE SELECTED
        </Typography>
      )}
    </div>
  );
};

export default DistributionTable;
